import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

export function usePWH508Permission() {
  const perms = useModulePermission(Modules.PWH508);

  return {
    canView: perms.canView,
    canApprove: perms.canApprove,
    hasAnyPermission: perms.hasAnyPermission,
  };
}
